import React from 'react';

export const ProcessingLeftImage = ({ normalizedFacility }) => { // Change prop name
  if (normalizedFacility === "China") { // Use normalizedFacility
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/processing/processing-cn-left.jpeg")`}}></div>);		  	    
  } else {
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/processing/processing-usa-left.jpeg")`}}></div>);		  	    
  }
};